export default "__VITE_PUBLIC_ASSET__71f37bee__"